'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:ScheduleJobsCtrl
 * @description
 * # ScheduleJobsCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('ScheduleJobsCtrl', function ($window, $scope, $log, $controller, $location, $timeout, $filter,
                                            $routeParams, $rootScope, moment, cfpLoadingBar, uiCalendarConfig,
                                            scheduleService, FlashService, modalService,
                                            momentService, fullCalendarService, eventsService,
                                            routeService, scheduleJobsService, scheduleJobsPrepService) {

    // private variables
    var scheduleJobsVm = this;
    var originalEvents = [];
    var scheduleCalendar = getScheduleCalendar;

    $controller('BaseController', {
      vm: scheduleJobsVm
    });

    // properties
    scheduleJobsVm.properties = {
      hasSelection: false,
      hasUnsavedChanges: false,
      maintenanceCustomersExist: true,
      inprogress: false,
      scheduleId: $routeParams.scheduleId
    };

    scheduleJobsVm.schedule = scheduleJobsPrepService.schedule;
    scheduleJobsVm.maintenanceCustomerList = scheduleJobsPrepService.maintenanceCustomers;
    scheduleJobsVm.selectedCustomers = [];
    /**
     *
     * @type {{events: Job[]}[]}
     */
    scheduleJobsVm.eventSources = [{
      events: scheduleJobsPrepService.jobs.map(value => {
        value.editable = !value.arrived;
        return value;
      })
    }];

    var start = momentService.getMonthStart(scheduleJobsVm.schedule.monthYearFor).format('YYYY-MM-DD');
    var end = momentService.getMonthEnd(scheduleJobsVm.schedule.monthYearFor).add(1, 'hour').format('YYYY-MM-DD');
    scheduleJobsVm.uiConfig = fullCalendarService.getDefaultUIConfig({
      defaultDate: getDefaultDate(getEvents()),
      defaultView: 'agendaDay',
      eventClick: getEventDetails,
      viewRender: dayChanged,
      eventDrop: eventDropped,
      validRange: {
        start: start,
        end: end
      },
      timezone: 'local'
    });

    var unsavedChangesModal = {
      closeButtonText: 'Cancel',
      actionButtonText: 'Ignore Changes',
      headerText: 'Unsaved Changes',
      bodyText: 'You have unsaved changes. Leave the page?'
    };

    var onBeforeUnloadUnsubscribe = eventsService.subscribe(eventsService.onBeforeUnloadEvent, onBeforeUnload);

    function onBeforeUnload(event) {
      if (scheduleJobsVm.properties.hasUnsavedChanges) {
        FlashService.warning('You have unsaved changes');
        event.preventDefault();
      }
    }

    var onRouteChangeUnsubscribe = eventsService.subscribe(eventsService.routeChangeStartEvent, onRouteChange);
    var onLoggingOutUnsubscribe = eventsService.subscribe(eventsService.loggedOutStartEvent, onLoggingOut);

    function onRouteChange(event, next) {
      if (scheduleJobsVm.properties.hasUnsavedChanges) {
        modalService.showModal({}, unsavedChangesModal)
          .then(function () {
            unsubscribeEvents();
            $location.path(routeService.getPathFromRoute(next));
          });

        event.preventDefault();
      }
    }

    function onLoggingOut(event) {
      if (scheduleJobsVm.properties.hasUnsavedChanges) {
        modalService.showModal({}, unsavedChangesModal)
          .then(function () {
            scheduleJobsVm.properties.hasUnsavedChanges = false;
            // TODO: Temporary measure below. Log user out here
            $location.path('/login');
          });

        event.preventDefault();
      }
    }

    function unsubscribeEvents() {
      onRouteChangeUnsubscribe();
      onBeforeUnloadUnsubscribe();
      onLoggingOutUnsubscribe();
    }

    // public methods
    scheduleJobsVm.addToDay = addToDay;

    scheduleJobsVm.removeFromDay = removeFromDay;
    scheduleJobsVm.saveJobs = saveJobs;
    scheduleJobsVm.downloadSchedule = downloadSchedule;
    scheduleJobsVm.selectCustomer = selectCustomer;
    scheduleJobsVm.copyToDay = copyToDay;
    scheduleJobsVm.addNotes = addNotes;

    scheduleJobsVm.baseActivate(activate);

    return scheduleJobsVm;

    function activate() {
      var events = getEvents();
      scheduleJobsPrepService.maintenanceCustomers.forEach(function (customer) {
        customer.datesAdded = momentService.getDatesArray(events, customer.id,
          customer.homeId, customer.orderId);
      });
    }

    // noinspection JSUnusedLocalSymbols
    function eventDropped(event, delta, revertFunc) { // jshint ignore: line
      scheduleJobsService
        .getAllEventsMatching(scheduleJobsVm.eventSources[0].events,
          function (item) {
            return +item._id === +event._id;
          })
        .forEach(function (item) {
          scheduleJobsService.updateEventDatesUtc(item, event.start, event.end);
          scheduleJobsVm.properties.hasUnsavedChanges = true;
        });
    }

    function addToDay(index, remove) {
      var view = fullCalendarService.getView(scheduleCalendar());
      var currentMoment = momentService.getCurrentMoment(view);
      var dayId = momentService.getUtcDayId(currentMoment);
      var events = scheduleJobsVm.eventSources[0].events;
      var maintenanceCustomers = scheduleJobsVm.maintenanceCustomerList;
      var viewType = view.type;

      if (viewType !== 'agendaDay') {
        FlashService.Error('Please select day view');
        return;
      }

      if (remove) {
        removeFromDay(index);
        return;
      }

      var jobParameters = {
        index: index,
        viewType: viewType,
        currentMoment: currentMoment,
        events: events,
        customers: maintenanceCustomers,
        dayId: dayId
      };

      addJobToDay(jobParameters);
    }

    function saveJobs(continueEditing) {
      var jobs = scheduleJobsVm.eventSources[0].events;
      var allCustomersInSchedule = checkAllInSchedule(jobs, scheduleJobsVm.maintenanceCustomerList);

      if (!allCustomersInSchedule) {
        var modalOptions = setupModalOptions();
        modalService.showModal({}, modalOptions)
          .then(doSave.bind(null, continueEditing, jobs));

        return;
      }

      doSave(continueEditing, jobs);
    }

    function downloadSchedule() {
      scheduleJobsVm.properties.inprogress = true;
      cfpLoadingBar.start();
      var id = scheduleJobsVm.properties.scheduleId;
      var filename = scheduleJobsVm.schedule.recipient + '-' + scheduleJobsVm.schedule.monthYearFor;
      return scheduleService.download(id, filename)
        .finally(function () {
          scheduleJobsVm.properties.inprogress = false;
          cfpLoadingBar.complete();
        });
    }

    function selectCustomer(index) {
      var customer = scheduleJobsVm.maintenanceCustomerList[index];
      if (customer.isSelected) {
        var removeIndex = scheduleJobsVm.selectedCustomers.indexOf(customer.id);
        scheduleJobsVm.selectedCustomers.splice(removeIndex, 1);
      } else {
        scheduleJobsVm.selectedCustomers.push(customer.id);
      }

      customer.isSelected = !customer.isSelected;
      scheduleJobsVm.properties.hasSelection = scheduleJobsVm.selectedCustomers.length > 0;
    }

    function copyToDay() {
      if (scheduleJobsVm.properties.hasUnsavedChanges) {
        FlashService.Error('You have unsaved changes. Please save your changes to the schedule first');
        return;
      }

      var modalOptions = setupModalOptions();
      var modalDefaults = {
        templateUrl: '/views/copyToDay.html'
      };
      var view = fullCalendarService.getView(scheduleCalendar());
      var dayId = momentService.getUtcDayId(momentService.getCurrentMoment(view));
      modalOptions.headerText = 'Copy Customers to Day';
      modalOptions.minDate = momentService.getMonthStart(scheduleJobsVm.schedule.monthYearFor).toDate().toISOString();
      modalOptions.maxDate = momentService.getMonthEnd(scheduleJobsVm.schedule.monthYearFor).toDate().toISOString();
      modalOptions.defaultDate = momentService.getCurrentMoment(view).add(14, 'd').toDate().toISOString();
      modalOptions.datesDisabled = momentService.getWeekendDates(modalOptions.minDate, modalOptions.maxDate);

      if (modalOptions.defaultDate > modalOptions.maxDate) {
        FlashService.Error('Can\'t copy to day outside the schedule month');
        return;
      }

      modalService.showModal(modalDefaults, modalOptions)
        .then(doCopy.bind(null, dayId));
    }

    function addNotes(customer) {
      if (scheduleJobsVm.properties.hasUnsavedChanges) {
        FlashService.Error('You have unsaved changes. Please save your changes to the schedule first');
        return;
      }

      var modalOptions = setupModalOptions();
      var modalDefaults = {
        templateUrl: '/views/addnotes.html'
      };

      var view = fullCalendarService.getView(scheduleCalendar());
      var dayId = momentService.getUtcDayId(momentService.getCurrentMoment(view));
      var index = getCustomerJobIndex(customer, dayId);
      var job = getCustomerJob(customer, dayId);
      modalOptions.headerText = 'Add Job Notes';
      modalOptions.notes = job.notes;
      modalService.showModal(modalDefaults, modalOptions)
        .then(doAddNotes.bind(null, index));
    }

    function addJobToDay(jobParameters) {
      if (!jobParameters) {
        throw new Error('jobParameters is not defined');
      }

      var expectedKeys = ['index', 'viewType', 'currentMoment', 'events', 'customers', 'dayId'];
      var keys = Object.keys(jobParameters);

      if (keys.sort().join().indexOf(expectedKeys.sort().join()) === -1) {
        throw new Error('Some properties where undefined. Expected ' +
          expectedKeys.join(', ') + ' but found ' + keys.join(', '));
      }


      var index = jobParameters.index;
      var viewType = jobParameters.viewType;
      var currentMoment = jobParameters.currentMoment;
      var events = jobParameters.events;
      var maintenanceCustomers = jobParameters.customers;
      var dayId = jobParameters.dayId;

      if (viewType !== 'agendaDay') {
        $window.alert('Please select day view');
        return;
      }

      var maintenanceCustomer = maintenanceCustomers[index];
      var time = fullCalendarService.getAvailableTimeOnDay(events, dayId, maintenanceCustomer.hoursPerVisit);

      if (!time.available) {
        FlashService.clear();
        FlashService.Error('Customer cannot fit in day. ' + time.remaining + ' hours left');
        return {
          success: false
        };
      }

      if (!time.latestMoment) {
        FlashService.warning('Jobs in day need to be moved to fit in customer');
        return {
          success: false
        };
      }

      var customer = maintenanceCustomers[index];
      var startMoment = (time.latestMoment || currentMoment).clone();
      var endMoment = startMoment.clone().add(customer.hoursPerVisit, 'h');

      var jobStart = startMoment.format('YYYY-MM-DDTHH:mm:ss.sss');
      var jobEnd = endMoment.format('YYYY-MM-DDTHH:mm:ss.sss');
      customer.selected = true;
      customer.datesAdded = null;

      events.push({
        customerId: customer.id,
        dayId: momentService.getUtcDayId(currentMoment),
        title: getEventTitle(customer),
        startMoment: startMoment,
        endMoment: endMoment,
        start: jobStart,
        end: jobEnd,
        duration: customer.hoursPerVisit,
        timestamp: currentMoment.valueOf(),
        jobDate: jobStart,
        startDateTime: jobStart,
        endDateTime: jobEnd,
        homeId: customer.homeId,
        orderId: customer.orderId,
        notes: customer.notes,
        stick: true
      });

      customer.datesAdded = momentService.getDatesArray(events, customer.id,
        customer.homeId, customer.orderId);
      FlashService.clear();
      FlashService.Success(fullName(customer) + ' added to Schedule');
      scheduleJobsVm.properties.hasUnsavedChanges = true;
      return {
        success: true
      };
    }

    function removeFromDay(index) {
      scheduleJobsVm.maintenanceCustomerList[index].isSelected = false;
      var view = fullCalendarService.getView(scheduleCalendar());
      var currentMoment = momentService.getCurrentMoment(view);

      var customer = scheduleJobsVm.maintenanceCustomerList[index];
      var dayId = momentService.getUtcDayId(currentMoment);

      _.remove(scheduleJobsVm.eventSources[0].events, function (item) { // jshint ignore: line
        return item.dayId === dayId &&
          item.customerId === customer.id &&
          item.homeId === customer.homeId &&
          item.orderId === customer.orderId;
      });

      customer.selected = false;
      customer.datesAdded = momentService
        .getDatesArray(scheduleJobsVm.eventSources[0].events, customer.id,
          customer.homeId, customer.orderId);
      FlashService.clear();
      FlashService.Success(fullName(customer) + ' removed from Schedule');
      scheduleJobsVm.properties.hasUnsavedChanges = true;
    }

    function doSave(continueEditing, jobs) {
      scheduleJobsVm.properties.inprogress = true;
      cfpLoadingBar.start();

      scheduleService.saveJobs(scheduleJobsVm.properties.scheduleId, jobs)
        .then(function () {
          FlashService.Success('Schedule saved');
          if (!continueEditing) {
            $location.path('/schedules/' + scheduleJobsVm.properties.scheduleId);
          }

          scheduleJobsVm.properties.hasUnsavedChanges = false;
        })
        .catch(function (error) {
          FlashService.Error(`Saving schedule failed: ${error.message}`);
        })
        .finally(function () {
          scheduleJobsVm.properties.inprogress = false;
          cfpLoadingBar.complete();
        });
    }

    function setupModalOptions() {
      return {
        closeButtonText: 'Cancel',
        actionButtonText: 'Yes',
        headerText: 'Save Schedule?',
        bodyText: 'This schedule does not include all customers on the list. Are you sure you want save?'
      };
    }

    function getEventDetails(event) {
      var hasAddress = !!event.address;
      var customer = scheduleJobsVm.maintenanceCustomerList.filter(function (item) {
        return item.id === event.customerId;
      })[0];

      var address = hasAddress ? event.address : $filter('address')(customer);
      var eventDetails = '<strong>Customer</strong>: ' + event.title +
        '<br/><strong>Address</strong>: ' + address +
        '<br/><strong>Job Date</strong>: ' + event.start.format('dddd, MMMM Do YYYY') +
        '<br/><strong>Duration</strong>: ' + event.duration + ' hours' +
        '<br/><strong>Notes</strong>: ' + (!!event.notes ? event.notes : 'No notes available');
      var options = {
        headerText: 'Job Details',
        bodyText: eventDetails
      };
      modalService.showModal({}, options);
    }

    function doAddNotes(index, notes) {
      var events = scheduleJobsVm.eventSources[0].events;
      var event = events[index];
      event.notes = notes;
      event.className = event.className || [];
      getScheduleCalendar().fullCalendar('updateEvent', event);
      setUnsavedChanges(!!notes);
    }

    function doCopy(dayId, copyDate) {
      var selected = scheduleJobsVm.selectedCustomers;
      var events = scheduleJobsVm.eventSources[0].events;
      var copyDateMoment = moment(copyDate, 'DD/MM/YYYY').add(9, 'h');
      var viewType = fullCalendarService.getView(scheduleCalendar()).type;
      var copyDateDayId = momentService.getUtcDayId(copyDateMoment);
      var customerList = scheduleJobsVm.maintenanceCustomerList;

      var eventsToCopy = _.filter(events, function (event) { //jshint ignore: line
        return selected.indexOf(event.customerId) > -1 && event.dayId === dayId;
      });

      var numberOfEventsCopied = 0;
      for (var i = 0; i < eventsToCopy.length; i++) {
        var index = _.findIndex(customerList, function (customer) { //jshint ignore: line
          return eventsToCopy[i].customerId === customer.id;
        });

        var jobParameters = {
          index: index,
          viewType: viewType,
          currentMoment: copyDateMoment,
          events: events,
          customers: customerList,
          dayId: copyDateDayId
        };

        var result = addJobToDay(jobParameters);
        numberOfEventsCopied += result.success ? 1 : 0;
      }

      $log.info(eventsToCopy);
      clearCustomerSelection();
      if (numberOfEventsCopied === eventsToCopy.length) {
        FlashService.Success('Copy complete');
      } else {
        FlashService.warning('Copy finished with some errors');
      }
      // scheduleJobsVm.properties.hasUnsavedChanges = true;
    }

    function dayChanged(view, element) {
      var events = scheduleJobsVm.eventSources[0].events;
      var startTimestamp = momentService.getMomentFromView(view).valueOf();
      var endTimestamp = moment(view.intervalEnd).valueOf();

      scheduleJobsVm.properties.hasSelection = false;
      scheduleJobsVm.selectedCustomers = [];

      scheduleJobsVm.maintenanceCustomerList.forEach(function (customer) {
        customer.isSelected = false;
        var customerEvents = events.filter(item => item.customerId === customer.id &&
            item.homeId === customer.homeId &&
            item.orderId === customer.orderId &&
            item.timestamp >= startTimestamp &&
            item.timestamp <= endTimestamp);
        customer.selected = !!customerEvents.length;
        if (!!customerEvents.length) {
          console.log(customerEvents);
        }
        var numberOfArrivals = customerEvents.filter(item => !!item.arrived).length;
        customer.arrived = !!numberOfArrivals;
        customer.warning = !!numberOfArrivals ?
          numberOfArrivals > 1 ? numberOfArrivals : ''
          : undefined;
      });
    }

    function clearCustomerSelection() {
      angular.forEach(scheduleJobsVm.maintenanceCustomerList, function (value) {
        value.isSelected = false;
      });

      scheduleJobsVm.selectedCustomers = [];
      scheduleJobsVm.properties.hasSelection = scheduleJobsVm.selectedCustomers.length > 0;
    }

    function fullName(obj) {
      return obj.firstName + ' ' + obj.lastName;
    }

    function getEventTitle(obj) {
      return fullName(obj) + ' - ' + obj.postcode;
    }

    function checkAllInSchedule(events, customerList) {
      var uniqueCustomer = _.uniqBy(events, 'customerId'); //jshint ignore: line
      return uniqueCustomer.length === customerList.length;
    }

    function getEvents() {
      return scheduleJobsVm.eventSources[0].events;
    }

    function getCustomerJob(customer, dayId) {
      var events = getEvents();
      return events.filter(function (item) {
        return item.customerId === customer.id &&
          item.homeId === customer.homeId &&
          item.orderId === customer.orderId &&
          item.dayId === dayId;
      })[0];
    }

    function getCustomerJobIndex(customer, dayId) {
      var events = getEvents();
      return events.findIndex(function (item) {
        return item.customerId === customer.id &&
          item.homeId === customer.homeId &&
          item.orderId === customer.orderId &&
          item.dayId === dayId;
      });
    }

    function setUnsavedChanges(hasUnsavedChanges) {
      scheduleJobsVm.properties.hasUnsavedChanges = !!hasUnsavedChanges;
    }

    function getScheduleCalendar() {
      return uiCalendarConfig.calendars['myCalendar'];
    }

    function getDefaultDate(events) {
      var minDate = momentService.getMonthStart(scheduleJobsVm.schedule.monthYearFor);
      return events[0] ? moment(events[0].jobDate) : minDate;
    }
  });
